import { useEffect } from "react"
import { usePageSession } from "~/hooks/usePageSession"
import { registerGlobalFunction } from "../register"

interface Props {}

const FuncIsPageReady: React.FC<Props> = () => {
  const {
    pageSession: { isReady },
  } = usePageSession()

  useEffect(() => {
    if (window) {
      registerGlobalFunction("isPageReady", () => isReady)
    }
  }, [isReady])

  return null
}

export default FuncIsPageReady
